<template>
  <router-view />
</template>
<script>
  export default {
    name: 'EventoModule',
  }
</script>
